import React from 'react'
import moment from 'moment'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import type { PainterAdditionalWork } from './types'
import type { usePainterAdditionalWorkStyles } from './usePainterAdditionalWorkStyles'

interface ApprovedAdditionalWorkRowProps {
  item: PainterAdditionalWork
  classes: ReturnType<typeof usePainterAdditionalWorkStyles>
  collapsed?: boolean
}

export default function ApprovedAdditionalWorkRow({ item, classes, collapsed }: ApprovedAdditionalWorkRowProps) {
  return (
    <div className={classes.approvedRow}>
      <CheckCircleIcon className={classes.approvedIcon} />
      <span className={classes.approvedText}>Approved</span>
      {item.approvedDate && !collapsed && (
        <span className={classes.approvedDate}>{moment(item.approvedDate).format('MMMM D, YYYY')}</span>
      )}
    </div>
  )
}
